import { device } from '@accedo/xdk-core'
import { Lightning, VideoPlayer } from '@lightningjs/sdk'

import { ID as WORKSTATION } from '@accedo/xdk-device-workstation'
import { SPLASH_VIDEO } from '../../constants/paths'
import { getAsset } from '../../utils/image'
import { checkAutoPlay } from '../../utils/video'
import { getViewportSize } from '../../utils/viewport'

export default class SplashVideo extends Lightning.Component {
  private _canPlay: boolean

  static _template() {
    return {
      w: (w) => w,
      h: (h) => h,
    }
  }

  _firstActive() {
    let { width, height } = getViewportSize()

    if (this.stage.w === 1280) {
      // Increases dimensions of video player by 3/2 so that when it gets remapped to 720p it remains as if it were 1080p
      width *= 1.5
      height *= 1.5
    }

    VideoPlayer.consumer(this)
    VideoPlayer.size(width, height)
  }

  async _init() {
    const platform = device.platform
    this._canPlay = platform !== WORKSTATION ? true : await checkAutoPlay()
  }

  _active() {
    this.removeSplashLogo()

    if (!this._canPlay) {
      VideoPlayer.mute(true)
    }
    VideoPlayer.open(getAsset(SPLASH_VIDEO))
  }

  _inactive() {
    VideoPlayer.close()
  }

  $videoPlayerEvent(eventName) {
    if (eventName === 'Ended') {
      this.signal('redirectToLanding')
    }
  }

  removeSplashLogo() {
    document.getElementById('flo-logo').remove()
  }
}
